export default __webpack_public_path__ + "static/media/IMG_5550.8319424a.jpg";